// @ts-check

import { Controller } from "@hotwired/stimulus"
import VinculoMovimentacoesListagemController from "./vinculo_movimentacoes_listagem_controller"
import EstoqueProdutoMovimentacaoFormController from "./estoque_produto_movimentacao_form_controller"
import { formataNumero, parseNumberPtBR } from "../../../../../../src/helpers/format";

export default class VinculoMovimentacaoController extends Controller {
  static targets = [ "qtdeVinculada", "qtdeRestanteEntrada",
    "qtdeRestanteSaida", "movimentacaoSelect" ]

  static values = { "index": Number }
  static outlets = [ "vinculo-movimentacoes-listagem" ]

  connect() {
    this.#addEventListenerRecalcularQuantidadesToInput();
    this.#addEventListenerAtualizarQtdeRestanteEntradaAoMudarMovimentacaoReferencia();
    this.#atribuirQtdeRestanteSaidaAoAdicionarNovoVinculo();
  }

  remover() {
    const qtdeRestanteSaidaParaAdicionarNosVinculosRestantes = this.qtdeVinculadaValueFloat * -1;

    const todosVinculosAteOIndex = this.getVinculoMovimentacoesListagemOutlet.coletarTodosVinculosAteOIndex(this.getIndexValue);

    this.#recalcularVinculosRestantes(todosVinculosAteOIndex, this.getIndexValue, qtdeRestanteSaidaParaAdicionarNosVinculosRestantes);
  }

  /** @param {number} qtdeDiff */
  movimentacaoQtdeAtualizada(qtdeDiff) {
    this.getQtdeRestanteSaidaTarget.value = this.#formataNumero(this.qtdeRestanteSaidaValueFloat + qtdeDiff);
  }

  /** @returns {EstoqueProdutoMovimentacaoFormController} */
  get getEstoqueProdutoMovimentacaoFormOutlet() {
    return this.getVinculoMovimentacoesListagemOutlet.getEstoqueProdutoMovimentacaoFormOutlet;
  }

  /** @returns {VinculoMovimentacoesListagemController} */
  get getVinculoMovimentacoesListagemOutlet() {
    // @ts-ignore
    return this.vinculoMovimentacoesListagemOutlet;
  }

  /** @returns {HTMLInputElement} */
  get getQtdeVinculadaTarget() {
    // @ts-ignore
    return this.qtdeVinculadaTarget;
  }

  /** @returns {HTMLInputElement} */
  get getQtdeRestanteEntradaTarget() {
    // @ts-ignore
    return this.qtdeRestanteEntradaTarget;
  }

  /** @returns {HTMLInputElement} */
  get getQtdeRestanteSaidaTarget() {
    // @ts-ignore
    return this.qtdeRestanteSaidaTarget;
  }

  /** @returns {HTMLSelectElement} */
  get getMovimentacaoSelectTarget() {
    // @ts-ignore
    return this.movimentacaoSelectTarget;
  }

  /** @returns {Number} */
  get getIndexValue() {
    // @ts-ignore
    return this.indexValue;
  }

  /** @returns {number} */
  get qtdeRestanteSaidaValueFloat() {
    return parseNumberPtBR(this.getQtdeRestanteSaidaTarget.value);
  }

  /** @returns {number} */
  get qtdeVinculadaValueFloat() {
    return parseNumberPtBR(this.getQtdeVinculadaTarget.value);
  }

  /** @returns {number} */
  get qtdeRestanteEntradaValueFloat() {
    return parseNumberPtBR(this.getQtdeRestanteEntradaTarget.value);
  }

  /** @returns {number} */
  get getPrecisaoQuantidadeValue() {
    return this.getEstoqueProdutoMovimentacaoFormOutlet.getPrecisaoQuantidadeValue;
  }

  /** @returns {boolean} */
  get isDestroyed() {
    // Verificar se há input _destroy marcado como true
    const destroyInput = /** @type {HTMLInputElement} */ (this.element.querySelector('input[name*="_destroy"]'));
    return destroyInput.value == '1';
  }

  /** @returns {boolean} */
  get movimentacaoReferenciaIsSaidaValue() {
    // @ts-ignore
    return this.getEstoqueProdutoMovimentacaoFormOutlet.getIsSaidaValue;
  }

  /** @returns {void} */
  #addEventListenerRecalcularQuantidadesToInput() {
    const inputQtdeVinculada = this.getQtdeVinculadaTarget;

    inputQtdeVinculada.addEventListener('focus', () => {
      inputQtdeVinculada.setAttribute('data-valor-anterior', inputQtdeVinculada.value);
    });

    inputQtdeVinculada.addEventListener('change', () => {
      this.#recalcularQuantidades();
    });
  }

  /** @returns {void} */
  #addEventListenerAtualizarQtdeRestanteEntradaAoMudarMovimentacaoReferencia() {
    this.getMovimentacaoSelectTarget.addEventListener('selectize:movimentacaoVinculadaChanged', (event) => {
      const customEvent = /** @type {CustomEvent} */ (event);

      let novaQtdeRestanteDoVinculo = parseNumberPtBR(customEvent.detail.novaQtdeRestanteDoVinculo);

      novaQtdeRestanteDoVinculo -= this.qtdeVinculadaValueFloat;

      if (this.movimentacaoReferenciaIsSaidaValue) {
        this.getQtdeRestanteEntradaTarget.value = this.#formataNumero(novaQtdeRestanteDoVinculo);
      } else {
        this.getQtdeRestanteSaidaTarget.value = this.#formataNumero(novaQtdeRestanteDoVinculo);
      }
    });
  }

  /** @returns {void} */
  #atribuirQtdeRestanteSaidaAoAdicionarNovoVinculo() {
    if (this.getVinculoMovimentacoesListagemOutlet.getCarregandoVinculosIniciaisValue) return;

    debugger
    if (this.movimentacaoReferenciaIsSaidaValue) {
      this.getQtdeRestanteSaidaTarget.value = this.#formataNumero(this.getVinculoMovimentacoesListagemOutlet.buscarUltimoValorQtdeRestante());
    } else {
      this.getQtdeRestanteEntradaTarget.value = this.#formataNumero(this.getVinculoMovimentacoesListagemOutlet.buscarUltimoValorQtdeRestante());
    }
  }

  /**
   * @returns {void}
   */
  #recalcularQuantidades() {
    const changedQtdeVinculadaInput = this.getQtdeVinculadaTarget;

    const novaQuantidade = parseNumberPtBR(changedQtdeVinculadaInput.value);

    const qtdeDiff = this.#qtdeAlteradaDiff(changedQtdeVinculadaInput, novaQuantidade);

    const todosVinculosAteOIndex = this.getVinculoMovimentacoesListagemOutlet.coletarTodosVinculosAteOIndex(this.getIndexValue);

    this.#recalcularPrimeiroVinculoAlterado(this, qtdeDiff);
    this.#recalcularVinculosRestantes(todosVinculosAteOIndex, this.getIndexValue, qtdeDiff);
  }

  /**
   * @param {HTMLInputElement} changedQtdeVinculadaInput
   * @param {number} novaQuantidade
   * @returns {number}
   */
  #qtdeAlteradaDiff(changedQtdeVinculadaInput, novaQuantidade) {
    const valorAnteriorStr = changedQtdeVinculadaInput.getAttribute('data-valor-anterior') || '0';
    const qtdeVinculadaAnterior = parseNumberPtBR(valorAnteriorStr);

    return novaQuantidade - qtdeVinculadaAnterior;
  }

  /**
   * @param {VinculoMovimentacaoController} vinculoAlterado
   * @param {number} qtdeDiff
   * @returns {void}
   */
  #recalcularPrimeiroVinculoAlterado(vinculoAlterado, qtdeDiff) {
    vinculoAlterado.getQtdeRestanteEntradaTarget.value = this.#formataNumero(vinculoAlterado.qtdeRestanteEntradaValueFloat - qtdeDiff);
    vinculoAlterado.getQtdeRestanteSaidaTarget.value = this.#formataNumero(vinculoAlterado.qtdeRestanteSaidaValueFloat - qtdeDiff);
  }

  /**
   * @param {Array<VinculoMovimentacaoController>} todosVinculos
   * @param {number} index
   * @param {number} qtdeDiff
   * @returns {void}
   */
  #recalcularVinculosRestantes(todosVinculos, index, qtdeDiff) {
    for (const vinculo of todosVinculos) {
      if (vinculo.getIndexValue === index) continue;

      if (this.movimentacaoReferenciaIsSaidaValue) {
        vinculo.getQtdeRestanteSaidaTarget.value = this.#formataNumero(vinculo.qtdeRestanteSaidaValueFloat - qtdeDiff);
      } else {
        vinculo.getQtdeRestanteEntradaTarget.value = this.#formataNumero(vinculo.qtdeRestanteEntradaValueFloat - qtdeDiff);
      }
    }
  }

  /**
   * @param {number} value
   * @returns {string}
   */
  #formataNumero(value) {
    return formataNumero(value, this.getPrecisaoQuantidadeValue);
  }
}
